import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import {
  getLocalStore, getPermissionRestaurant,
  isEmptyObject,
  setLocalStore,
} from '../../../../utils/utils';
import {
  openSelectCurrentRestaurantModal,
  setCurrentRestaurant,
} from '../../../Setting/actions';
import { trans } from '../../../../localization/index';
import { setGeneralError } from '../../../../layout/components/UniversalModal/actions';
import NowSelect from '../../../../components/Common/NowSelect';
import { resetAuthentication } from '../../../../authentication/actions';
import Modal, {
  ModalAction,
  ModalBody,
  ModalButton,
  ModalHeader,
} from '../../../../components/Modal/Modal';
import { EnumLocalStorage, EnumMerchantPermission } from '../../../../constants/enum';

class ChooseRestaurantModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      curRestaurant: props.currentRestaurant,
    }
  }
  
  componentDidMount() {
    const {
      currentRestaurant,
      restaurants,
      setCurrentRestaurantConnect,
      isShowAllRestaurantOption,
    } = this.props;
    const currentRestaurantOld = getLocalStore(
      EnumLocalStorage.CURRENT_RESTAURANT,
    );
    if (
      !isEmptyObject(currentRestaurantOld) &&
      isEmptyObject(currentRestaurant)
    ) {
      const { restaurantId } = currentRestaurantOld;
      const currentNewRestaurant = restaurants.find(
        restaurant => restaurant.restaurant_id === restaurantId,
      );
      if (!isEmptyObject(currentNewRestaurant)) {
        if (
          !isShowAllRestaurantOption &&
          currentNewRestaurant.restaurant_id === 0
        ) {
          const [firstRestaurant] = restaurants;
          setCurrentRestaurantConnect(firstRestaurant);
        } else {
          setCurrentRestaurantConnect(currentNewRestaurant);
        }
      }
    }
  }

  componentDidUpdate() {
    const {
      isShowAllRestaurantOption,
      currentRestaurant,
      restaurants,
      setCurrentRestaurantConnect,
    } = this.props;
    if (!isShowAllRestaurantOption && currentRestaurant.restaurant_id === 0) {
      const [firstRestaurant] = restaurants;
      setCurrentRestaurantConnect(firstRestaurant);
    }
  }

  handleOpenRestaurant = () => {
    const {
      setCurrentRestaurantConnect,
      openSelectCurrentRestaurantModalConnect,
      setGeneralErrorConnect,
      handleRefreshList,
    } = this.props;
    const { curRestaurant } = this.state;
    if (!isEmptyObject(curRestaurant)) {
      setCurrentRestaurantConnect(curRestaurant)
      setLocalStore(EnumLocalStorage.CURRENT_RESTAURANT, {
        restaurantId: curRestaurant.restaurant_id,
      });
      handleRefreshList(curRestaurant);
      openSelectCurrentRestaurantModalConnect(false);
    } else {
      setGeneralErrorConnect(trans('mod_choose_restaurant_process'));
    }
  };

  allRestaurantOption = () => ({
    restaurant_id: 0,
    name: trans('mod_all_restaurant'),
  });

  handleChangeRestaurant = (value) => {
    const {
      currentRestaurant,
      isChangeRestaurant,
      handleRefreshList,
    } = this.props;
    if (value == null || value.value !== currentRestaurant.value) {
      const restaurant =
        !isEmptyObject(value) && !isEmptyObject(value.data)
          ? value.data
          : this.allRestaurantOption();
      this.setState({ curRestaurant: restaurant });
      if (!isChangeRestaurant) {
        handleRefreshList(restaurant);
      }
    }
  };

  restaurantOptions = (isHaveRollAllRestaurant) => {
    const { restaurants } = this.props;
    let restaurantOptions = getPermissionRestaurant(restaurants, EnumMerchantPermission.ORDER_ALL.id).map(res => ({
      value: res.restaurant_id,
      label: res.is_use_partner_app ? (
        <div className="choose-restaurant-modal-option">
          {res.name}
          <div className="choose-restaurant-modal-option-tag">
            {trans('merchant_transfer_simpleDialog_text_transferred')}
          </div>
        </div>
      ) : res.name,
      data: res,
    }));

    if (isHaveRollAllRestaurant) {
      const { restaurant_id: value, name: label } = this.allRestaurantOption();
      restaurantOptions = [
        {
          value,
          label,
          data: this.allRestaurantOption(),
        },
        ...restaurantOptions,
      ];
    }
    return restaurantOptions;
  };

  render() {
    const {
      isChangeRestaurant,
      currentRestaurant,
      restaurants,
      isShowAllRestaurantOption,
      setting,
    } = this.props;
    const { curRestaurant } = this.state;
    if (isEmptyObject(restaurants)) {
      return null;
    }
    const {
      restaurant_id: restaurantId = 0,
      name = trans('mod_choose_restaurant'),
    } = curRestaurant || currentRestaurant;
    const restaurant = { value: restaurantId, label: name };
    const isHaveRollAllRestaurant =
      isShowAllRestaurantOption && setting.is_show_all_restaurants;
    const restaurantOptions = this.restaurantOptions(isHaveRollAllRestaurant);
    const isShowCurrentRestaurant = restaurantOptions.length > 0 && (
      isEmptyObject(currentRestaurant) || isChangeRestaurant);

    return (
      <Modal isOpen={isShowCurrentRestaurant}>
        <React.Fragment>
          <ModalHeader>{trans('mod_choose_restaurant_process')}</ModalHeader>
          <ModalBody>
            <NowSelect
              value={restaurant}
              options={restaurantOptions}
              onChange={this.handleChangeRestaurant}
              isClearable={isHaveRollAllRestaurant}
            />
          </ModalBody>
          <ModalAction>
            <ModalButton styleType={restaurant?'red':'white'} onClick={this.handleOpenRestaurant}>
              {trans('mod_restaurant_open')}
            </ModalButton>
          </ModalAction>
        </React.Fragment>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  restaurants: state.app.restaurants,
  setting: state.app.setting,
  isChangeRestaurant: state.setting.isChangeRestaurant,
  currentRestaurant: state.setting.currentRestaurant,
});

const mapDispatchToProps = dispatch => ({
  setCurrentRestaurantConnect: (restaurant) => {
    dispatch(setCurrentRestaurant(restaurant));
  },
  setGeneralErrorConnect: (message) => {
    dispatch(setGeneralError(message));
  },
  openSelectCurrentRestaurantModalConnect: (isShow) => {
    dispatch(openSelectCurrentRestaurantModal(isShow));
  },
  resetAuthenticationConnect: () => {
    dispatch(resetAuthentication());
  },
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(ChooseRestaurantModal),
);



// WEBPACK FOOTER //
// ./foody/src/pages/Order/OrderManagement/components/ChooseRestaurantModal.jsx